import { useIntl } from 'react-intl';

import SearchIcon from 'icons/search-icon.svg';

import messages from './messages';
import { Wrapper } from './styles';

const SearchLink = ({ className }: { className?: string }) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper href="/app/search" aria-label={formatMessage(messages.linkText)}>
			<SearchIcon />
		</Wrapper>
	);
};

export default SearchLink;
